import React, { useState } from "react";
import { Box, Flex, HStack, Switch, Text, Tooltip } from "@chakra-ui/react";
import Table1 from "./components/Table1";
import Exports from "./components/Exports";
import Import from "./components/Import";
import PageToolbar from "../../components/shared/PageToolbar";
import { Panel } from "../../components/shared/Section";
import { useSupplierRetailer } from "../../wrappers/SupplierRetailerContext";
import { neutral, type } from "../../theme/tokens";

// Remembered per browser, same as Ranging — but under its own key, so hiding
// discontinued lines on one page does not silently change the other.
const STORAGE_KEY = "spearbi_margin_hide_discontinued";

const Margin = () => {
  const { selectedRetailer, selectedSupplier } = useSupplierRetailer();
  const isAdmin = parseInt(localStorage.getItem("userid")) <= 2;

  const [hideDiscontinued, setHideDiscontinued] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "true";
    } catch (e) {
      return false;
    }
  });
  // Reported up by the table once it has the article list, so the label can say
  // how many rows the switch is holding back.
  const [discontinuedCount, setDiscontinuedCount] = useState(0);

  const handleToggle = (e) => {
    const next = e.target.checked;
    setHideDiscontinued(next);
    try {
      localStorage.setItem(STORAGE_KEY, String(next));
    } catch (err) {
      /* private mode — the toggle still works for this session */
    }
  };

  return (
    <Box>
      <PageToolbar
        description="Retail selling price and margin by article, month by month"
        filters={
          <Tooltip label="Articles whose brand or description carries a 'disc' marker" openDelay={400} fontSize="xs">
            <HStack spacing={2}>
              <Switch id="margin-hide-discontinued" size="sm" colorScheme="brand" isChecked={hideDiscontinued} onChange={handleToggle} />
              <Text as="label" htmlFor="margin-hide-discontinued" fontSize={type.size.small} color={neutral[600]} cursor="pointer" userSelect="none" whiteSpace="nowrap">
                Hide discontinued
                {discontinuedCount > 0 && (
                  <Text as="span" color={neutral[400]} ml={1}>
                    ({discontinuedCount})
                  </Text>
                )}
              </Text>
            </HStack>
          </Tooltip>
        }
        actions={
          <Flex gap={2} align="center">
            <Exports supplier={selectedSupplier} retailer={selectedRetailer} hideDiscontinued={hideDiscontinued} />
            {isAdmin && <Import supplier={selectedSupplier} retailer={selectedRetailer} />}
          </Flex>
        }
      />

      <Panel padded={false}>
        {/* The table owns its own scrolling now — it is the scroll container the
            frozen header sticks to, so this wrapper must not scroll as well.
            It previously capped the height and scrolled both axes, which left
            the header pinned to a box that never moved while the content slid
            past underneath it. */}
        <Box>
          <Table1
            supplier={selectedSupplier}
            retailer={selectedRetailer}
            hideDiscontinued={hideDiscontinued}
            onDiscontinuedCount={setDiscontinuedCount}
          />
        </Box>
      </Panel>
    </Box>
  );
};

export default Margin;
